@let kontraktGuid = kontraktGuid$ | async;

<rask-virkeskop-validation-message
    [entityGuid]="kontraktGuid"
    [messageId]="allRules">
</rask-virkeskop-validation-message>
<div class="row" [formGroup]="formGroup">
    <rask-input class="col-4" label="Total kvantitet ca, m3fub"
        [inputProcessor]="seIntProcessor"
        formControlName="kontraktTotalKvantitet">
    </rask-input>
    <div class="col-4 d-flex flex-column">
        <rask-input label="Kontraktets belopp, kr"
            [inputProcessor]="seIntProcessor"
            formControlName="kontraktsbelopp"
            raskVirkeskopRule
            [entityGuid]="kontraktGuid"
            [messageId]="beloppRules">
        </rask-input>
        <rask-checkbox id="visaIUtskrift" text="Visa i utskrift"
            formControlName="visaKontraktsbeloppIUtskrift"
            (change)="onInkluderaIUtskriftChange($event)">
        </rask-checkbox>
    </div>
    <rask-simple-selector
                label="kr/inmätt"
                class="col-4"
                formControlName="ersattningstyp"
                [values]="krPerInmattSelectorOptions"
                bindLabel="text"
                [required]="true"
                bindValue="value">
    </rask-simple-selector>
</div>